export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-array/src/threshold/sturges.js
// module id = J0XR
// module chunks = 0